export default {
    currentVideoObject: null,
    currentVideoStatus: null,
    currentVideoTranscript: null,
    currentVideoDurationWatched: null,
    currentPromoVideoObject: null,
    copiedPlaylistObject: null,
    originalVideoCode: null,
    originalVideoTitle: null,
    videoEndMessage: ['Good for you! Hope you got the insight you were looking for!', 'Yay you! There is more coming your way!', 'And that is just for starters! Click for more.', 'Do not miss out! Invest in yourself and watch more Tone videos here.', 'Yay you! Now take the advice and run with it!', 'Congrats! You just did something great for you.', 'No time like the present. Keep on clicking for more great advice!', 'Woo hoo! You did it!', 'Congratulations! Today is your day.', 'Well done. Thanks for stopping by!', 'We are proud of you. Very, very proud of you!', 'Congrats! We are so happy you stopped by.', 'Thanks for taking time for you!', 'Congratulations! You did it!', 'Congrats! Now have a fantastic rest of your day!', 'Well done, my friend. Keep up the good work!', 'Way to take time out for you!', 'Yippee skippee! Today just got a little bit sweeter.', 'Congratulations! What an achievement.', 'Woo hoo! Have a Tone-tastic day!', 'Congrats! This is only the beginning.', 'You did it! Sending a virtual high five your way!'],
    videoEndGif: ['../assets/baloonssmall.png', '../assets/fireworkssmall.png', '../assets/confettismall.png', '../assets/sparkelssmall.gif'],
    videoSubCategories: null,
    corporatePayload: null,
    B2BVideos: null,
    b2BTopVideo: null,
    taggedEmailList: null,
    archivePlaylistObject: null,
    userNewPlaylistObject: null,
    trendingNewPlaylistObject: null,
    corpNewPlaylistObject: null,
    itemChangeInPlaylist: null,
    servicePodcast: null
}



// WEBPACK FOOTER //
// ./src/store/videoplayer/state.js